// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.img-vip[data-v-7403a0aa] {\n  position: absolute;\n  top: 25px;\n  right: 39px;\n  z-index: 9;\n}\n", ""]);
// Exports
module.exports = exports;
